








import {computed, defineComponent, onBeforeUnmount, onMounted, ref} from '@vue/composition-api';
import OptionFilter from './option-filter.vue';
import SectionTab from './section-tab.vue';

export default defineComponent({
  name: 'price-rating-filter',
  components: {
    OptionFilter,
    SectionTab,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  setup(props, {emit, root}) {
    const defaultValue = 'Any Rating';
    const componentValue = ref(props.value || defaultValue);
    const isFilterOpen = ref(false);
    const priceOptions = [defaultValue, '$', '$$', '$$$', '$$$$', '$$$$$'];

    const closeFilter = (value: string | MouseEvent) => {
      if (typeof value === 'string' && value !== 'price-rating-filter') {
        isFilterOpen.value = false;
      } else if (typeof value !== 'string') {
        isFilterOpen.value = false;
      }
    };

    onMounted(() => {
      document.addEventListener('click', closeFilter);
      root.$on('intersections-filter-open', closeFilter);
    });
    onBeforeUnmount(() => {
      document.removeEventListener('click', closeFilter);
      root.$off('intersections-filter-open', closeFilter);
    });

    const onValueSave = (value: string) => {
      componentValue.value = value;
      isFilterOpen.value = false;
      emit('change', value === defaultValue ? null : value);
    };

    const filterValue = computed(() => {
      return defaultValue === componentValue.value ? '' : `: ${componentValue.value}`;
    });

    const openFilter = () => {
      root.$emit('intersections-filter-open', 'price-rating-filter');
      isFilterOpen.value = true;
    };

    return {
      componentValue,
      onValueSave,
      openFilter,
      isFilterOpen,
      defaultValue,
      filterValue,
      priceOptions,
    };
  },
});
